import styled from "styled-components";

export const StyledFilterSearchBoxWrapper = styled.div`
    padding: 0 23px 0 12px;
    margin-top: 8px;
    min-width: 220px;
`;
